export default "__VITE_ASSET__B5Ott9wW__"